var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24ZM35 34.079V31.4057C35 29.9877 34.4431 28.6278 33.4518 27.6251C32.4605 26.6224 31.1161 26.0592 29.7142 26.0592H19.1425C17.7407 26.0592 16.3962 26.6224 15.4049 27.6251C14.4136 28.6278 13.8567 29.9877 13.8567 31.4057V34.079H35ZM29.5184 17.3102C29.5184 20.1288 27.2395 22.4137 24.4284 22.4137C21.6172 22.4137 19.3383 20.1288 19.3383 17.3102C19.3383 14.4916 21.6172 12.2066 24.4284 12.2066C27.2395 12.2066 29.5184 14.4916 29.5184 17.3102Z",
    fill: "#C9CCD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.1fb25a8397d0a6d023d647578aaa6be2.svg";
export { ForwardRef as ReactComponent };